import { render, staticRenderFns } from "./StudentSelectMenu.vue?vue&type=template&id=b0cbd70e&scoped=true&"
import script from "./StudentSelectMenu.vue?vue&type=script&lang=ts&"
export * from "./StudentSelectMenu.vue?vue&type=script&lang=ts&"
import style0 from "./StudentSelectMenu.vue?vue&type=style&index=0&id=b0cbd70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbd70e",
  null
  
)

export default component.exports